<div class="existing-files" *ngIf="files.length">
  <div class="existing-files-title">Existing files</div>

  <div class="existing-files-list">
    <button type="button" class="file-chip" *ngFor="let file of files" (click)="openPreview(file)"
      [class.active]="selectedFile?.id === file.id">
      {{ getFileName(file) }}
    </button>
  </div>
</div>

<div class="preview-modal-backdrop" *ngIf="selectedFile" (click)="closePreview()"></div>

<div class="preview-modal" *ngIf="selectedFile" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
  <div class="preview-head">
    <div class="preview-title">{{ getFileName(selectedFile) }}</div>
    <button type="button" class="ghost-btn small" (click)="closePreview()">Close</button>
  </div>

  <div class="preview-body">
    <ng-container [ngSwitch]="getPreviewKind(selectedFile)">
      <img *ngSwitchCase="'image'" [src]="selectedFile.url" [alt]="getFileName(selectedFile)" class="preview-image" />

      <iframe *ngSwitchCase="'pdf'" class="preview-frame" [src]="getIframeSrc(selectedFile)"
        title="PDF preview"></iframe>

      <iframe *ngSwitchCase="'text'" class="preview-frame" [src]="getIframeSrc(selectedFile)"
        title="Text preview"></iframe>

      <iframe *ngSwitchCase="'word'" class="preview-frame" [src]="getWordIframeSrc(selectedFile)"
        title="Word preview"></iframe>

      <div *ngSwitchDefault class="preview-fallback">
        Preview is not available for this file type.
        <a [href]="selectedFile.url" target="_blank" rel="noopener noreferrer">Open file</a>
      </div>
    </ng-container>
  </div>
</div>